import { getItemPathByItemType } from '@modules/documents';
import { TItem } from '@modules/items';
import { SmartTableCell } from '@shared/components';
import { Link } from 'react-router-dom';
import { isTSearchItem, TSearchItem } from '../types';

type TProps = {
  items: (TItem | TSearchItem)[];
};

const SearchMatches = ({ items }: TProps) => {
  return (
    <ul>
      {items.map((item) => (
        <li key={item._id} className="p-[6px] pr-[18px] hover:bg-gray-100 cursor-pointer">
          <Link
            to={`/${getItemPathByItemType(item.type)}/${item._id}`}
            target="_blank"
            onClick={(e) => e.stopPropagation()}
          >
            <SmartTableCell
              wrap="layout-only"
              variant={{ kind: 'item', item }}
              tooltip={{ threshold: 70 }}
              descriptionHtml={isTSearchItem(item) ? item.snippet : item.recentData?.location}
            />
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default SearchMatches;
